module.exports = __webpack_public_path__ + "static/media/008_addons@2x.3c0a79b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/008_addons@2x.png
// module id = 570
// module chunks = 0